<template>
    <div
        :style="[marginTop ? { marginTop: marginTop } : '', marginBottom ? { marginBottom: marginBottom } : '']"
        class="component component__spacing"
    ></div>
</template>

<script>
export default {
  name: 'component-spacing',
  props: {
    marginTop: {
      type: String,
      default: ''
    },
    marginBottom: {
      type: String,
      default: ''
    }
  }
}
</script>
